import { API_AUTH } from ".././common";

const DsBankApi = {
  list: ({ sSearch, sMaNganHang, iPageSize, iPageIndex, isKhoa, isDangKyNhanPushBDSD }) =>
    API_AUTH.get(
      `banktaikhoan/danhsachtaikhoanbank?sSearch=${sSearch}&sMaNganHang=${sMaNganHang}&iPageSize=${iPageSize}&iPageIndex=${iPageIndex}&isKhoa=${isKhoa}&isDangKyNhanPushBDSD=${isDangKyNhanPushBDSD}`,
      {}
    ),
  addOrUpdate: (params) => API_AUTH.post("banktaikhoan/addorupdate", params),
  deleteTaiKhoan: ({ idTaiKhoan }) => API_AUTH.post("banktaikhoan/delete?iTaiKhoanId=" + idTaiKhoan),
  lienKetNganHang: ({ idTaiKhoan }) => API_AUTH.post("banktaikhoan/lienketnganhang?iTaiKhoanId=" + idTaiKhoan),
  xacThucOTPDangKyPushBDSD: ({ idTaiKhoan, maOtp }) => API_AUTH.post("banktaikhoan/xacThucOTPDangKyPushBDSD?iTaiKhoanId=" + idTaiKhoan+"&maOtp=" + maOtp),
  huyLienKetNganHang: ({ idTaiKhoan }) => API_AUTH.post("banktaikhoan/huylienketnganhang?iTaiKhoanId=" + idTaiKhoan),
  xacThucOTPHuyDangKyPushBDSD: ({ idTaiKhoan, maOtp }) => API_AUTH.post("banktaikhoan/xacThucOTPHuyDangKyPushBDSD?iTaiKhoanId=" + idTaiKhoan+"&maOtp=" + maOtp),
  
};

export default DsBankApi;
